import "./Home.module.css";
import { useEffect } from 'react';
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Vision from "./sections/Vision";
import Advantage from "./sections/Advantage";
import Services from "./sections/Services";
import Portfolio from "./sections/Portfolio";
import Contact from "./sections/Contact";
import Philosophy from "./sections/Philosophy";
function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in-view');
          const items = entry.target.querySelectorAll('[data-scroll-item]');
          items.forEach((item, i) => {
            (item as HTMLElement).style.transitionDelay = `${i * 500}ms`;
            item.classList.add('animate-in-view');
          });
          const heroEls = entry.target.querySelectorAll('[data-hero-item]');
          heroEls.forEach(el => {
            const h = el as HTMLElement;
            const delay = h.style.animationDelay;
            h.style.animation = 'none';
            h.offsetHeight;
            h.style.animation = '';
            h.style.animationDelay = delay;
            h.classList.add('hero-animate');
          });
        } else {
          entry.target.classList.remove('animate-in-view');
          const items = entry.target.querySelectorAll('[data-scroll-item]');
          items.forEach(item => {
            (item as HTMLElement).style.transitionDelay = '900ms';
            item.classList.remove('animate-in-view');
          });
          const heroEls = entry.target.querySelectorAll('[data-hero-item]');
          heroEls.forEach(el => {
            el.classList.remove('hero-animate');
          });
        }
      });
    }, {
      threshold: 0,
      rootMargin: '200px 0px -100px 0px'
    });
    const earlyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in-view');
        } else {
          entry.target.classList.remove('animate-in-view');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px 0px 0px'
    });
    const sections = document.querySelectorAll('[data-scroll-animate]');
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        section.classList.add('animate-in-view');
        const items = section.querySelectorAll('[data-scroll-item]');
        items.forEach((item, i) => {
          (item as HTMLElement).style.transitionDelay = `${i * 100}ms`;
          item.classList.add('animate-in-view');
        });
        const heroEls = section.querySelectorAll('[data-hero-item]');
        heroEls.forEach(el => {
          (el as HTMLElement).style.animationDelay = (el as HTMLElement).style.animationDelay;
          el.classList.add('hero-animate');
        });
      }
      observer.observe(section);
    });
    document.querySelectorAll('[data-scroll-item-early]').forEach(el => {
      earlyObserver.observe(el);
    });
    return () => {
      observer.disconnect();
      earlyObserver.disconnect();
    };
  }, []);
}
export default function HomePage() {
  useScrollReveal();
  return <div>
      <Header />
      <div data-scroll-animate><Vision /></div>
      <div data-scroll-animate><Portfolio /></div>
      <div data-scroll-animate><Advantage /></div>
      <div data-scroll-animate><Services /></div>
      <div data-scroll-animate="left"><Contact /></div>
      <div data-scroll-animate="left"><Philosophy /></div>
      <Footer />
    </div>;
}